import React from "react"
/*import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';*/
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import "../css/news.css";

/*import { LightgalleryProvider, LightgalleryItem } from "react-lightgallery";
import "../css/lightgallery.css";

const PhotoItem = ({ image, group, alt }) => (
  <div style={{  }} className="news-Image">
    <LightgalleryItem group={group} src={image}>
      <img src={image} alt={alt} style={{  }} />
    </LightgalleryItem>
  </div>
);*/

const newsData = data => (

  
  < Layout >

    <SEO
      title={`Chofly News | ${data.data.news.seoTitle}`}
      ogTitle={`Chofly News | ${data.data.news.seoTitle}`}
      ogURL="https://choflyelite-legacy.netlify.com"
      ogDescription={`Chofly News | ${data.data.news.seoTitle}`}
      ogURL={data.data.page ? `https://choflyelite-legacy.netlify.com/${data.data.page.slug}/` : ""}
      ogImage={data.data.news.featured_image && data.data.news.featured_image[0] ? `${'https://api.flotiq.com'}/image/400x0/${data.data.news.featured_image[0].id}.${data.data.news.featured_image[0].extension}` : ""}
      keywords={['Chofly News', 'Chofly Elite', 'ChoseN', 'Raid', 'Raid Shadow Legends', 'Twitch Streamer', 'YouTuber', 'Content Creator', 'YouTube Content Creator', 'Plarium Moderator',]}
    />

    <div className="container news">

        {/* <h1 dangerouslySetInnerHTML={{ __html: data.data.news.title}} /> */}
        <h1>{data.data.news.seoTitle}</h1>

        {data.data.news.featured_image_link ?
          <a href={data.data.news.featured_image_link} target="_blank" rel="noopener noreferrer" alt="Click to view in new tab" title="Click to view in new tab">
            <img src={data.data.news.featured_image && data.data.news.featured_image[0] ? `${'https://api.flotiq.com'}/image/0x0/${data.data.news.featured_image[0].id}.${data.data.news.featured_image[0].extension}` : ""} width="100%" height="auto" />
          </a>
        :
          <img src={data.data.news.featured_image && data.data.news.featured_image[0] ? `${'https://api.flotiq.com'}/image/0x0/${data.data.news.featured_image[0].id}.${data.data.news.featured_image[0].extension}` : ""} width="100%" height="auto" />
        }
        <div className="newsContent">
        <section dangerouslySetInnerHTML={{ __html: data.data.news.content}} />
        </div>

    </div>

</Layout >
)

export default newsData

export const query = graphql`
  query newsBySlug($slug: String!) {

    news(slug: {eq: $slug}) {
      id
      slug
      title
      titleClass
      seoTitle
      content
      featured_image {
        extension
        url
        id
      }
      featured_image_link
      publish
    }

  }
`
